module.exports = __webpack_public_path__ + "img/icon-subir-nube.356ad383.svg";